/** Un ou plusieurs indicateurs Qualiopi rattachés à un même champ. */
export type IndicatorRef = number | readonly number[]

export function indicatorList(ref: IndicatorRef): readonly number[] {
  return typeof ref === "number" ? [ref] : ref
}

/**
 * « 1 et 11 », ou « I1 et I11 » avec le préfixe « I ».
 *
 * @example
 * indicatorLabel([1, 11], "I") // "I1 et I11"
 */
export function indicatorLabel(ref: IndicatorRef, prefix: string = ""): string {
  return indicatorList(ref)
    .map((indicator) => `${prefix}${indicator}`)
    .join(" et ")
}
